import React from "react";
import "./App.css"
import { BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Home from "./Pages/Home";
import Holiday from "./Pages/Holiday/Holiday";
import Settings from "./Pages/Login/Settings";
import User from "./Pages/User/User";
import Category from "./Pages/Product/Category";
import SubCategory from "./Pages/Product/SubCategory";
import Product from "./Pages/Product/Product";
import UserAllocation from "./Pages/User/UserAllocation";
import Admin from "./Pages/User/Admin";
import Doctor from "./Pages/User/Doctor";
import Employee from "./Pages/Employee/Employee";
import Patient from "./Pages/User/Patient";
import Agent from "./Pages/User/Agent";
import ShopOwner from "./Pages/User/ShopOwner";
import Vendor from "./Pages/User/Vendor";
import Service from "./Pages/Product/Service";
import Login from "./Pages/Login/Login";
import SignUp from "./Pages/Login/SignUp";
import Profile from "./Pages/Login/Profile";
import DAList from "./Pages/Da/DaList";
import TeamCreate from "./Pages/TeamCreate/TeamCreate";
import { Pos } from "./Pages/Sell/Pos";
import WorkAssignEmployee from "./Pages/WorkAssign/WorkAssignEmployee";
import DaEmployee from "./Pages/Employee/DaEmployee";
import EmployeePayroll from "./Pages/Employee/EmployeePayroll";
import ReviewQuestion from "./Pages/Review/ReviewQuestion";
import WorkAssign from "./Pages/WorkAssign/WorkAssign";
import GstAdd from "./Pages/Gst/GstAdd";
import GstList from "./Pages/Gst/GstList";
import PurchaseBillAdd from "./Pages/Purchase/PurchaseBillAdd";
import SellBillList from "./Pages/Sell/SellBillList";
import PurchaseReport from "./Pages/Purchase/PurchaseReport";
import SellReport from "./Pages/Sell/SellReport";
import EmployeeRole from "./Pages/Employee/EmployeeRole";
import EmployeeAssign from "./Pages/Employee/EmployeeAssign";
import PurchaseBillList from "./Pages/Purchase/PurchaseBillList";
import Order from "./Pages/Order/Order";
import DoctorPayRoll from "./Pages/PayRoll/DoctorPayRoll";
import { DoctorPaymentList } from "./Pages/PayRoll/DoctorPaymentList";
import AddService from "./Pages/Service/AddService";
import { PendingService } from "./Pages/Service/PendingService";
import { CompleteService } from "./Pages/Service/CompleteService";
import ConfirmCheckout from "./Pages/Order/ConfirmCheckout";
import OrderAddSerialNumber from "./Pages/Order/OrderAddSerialNumber";
import AssignServicePerson from "./Pages/ServiceRequest/AssignServicePerson";
import StoreOwner from "./Pages/User/StoreOwner";
import StoreConfirmCheckout from "./Pages/Order/StoreConfirmCheckout";
import CourierAdd from "./Pages/Courier/CourierAdd";
import CourierList from "./Pages/Courier/CourierList";
import UserAdd from "./Pages/User/UserAdd";
import CustomizedRequest from "./Pages/Order/CustomizedRequest";
import CustomizeTestData from "./Pages/Order/CustomizeTestData";
import Storewalletbalance from "./Pages/store/Storewalletbalance";
import ServiceRequentNotification from "./Pages/ServiceRequest/ServiceRequentNotification";
import IncomeReport from "./Pages/reports/IncomeReport";
import StockReport from "./Pages/reports/StockReport";
import GSTPurchaseReport from "./Pages/reports/GSTPurchaseReport";
import GSTSellReport from "./Pages/reports/GSTSellReport";
import ExpenditureReport from "./Pages/reports/ExpenditureReport";
import ProfitLossReport from "./Pages/reports/ProfitLossReport";
import SalaryReport from "./Pages/reports/SalaryReport";
import Hospital from "./Pages/User/Hospital";
import DiagnosticCenter from "./Pages/User/DiagnosticCenter";
import Audiometer from "./Pages/Product/Audiometer";
import Testbooking from "./Pages/Order/Testbooking";
import RefferProduct from "./Pages/Order/RefferProduct";
import GetApp from "./Pages/GetApp";
import EmployeeTracking from "./Pages/Employee/EmployeeTracking";
import ChamberAdd from "./Pages/User/ChamberAdd";
import SeniorMarketingExecutive from "./Pages/User/SeniorMarketingExecutive";


function App() {

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
         <Route path="/get-app" element={<GetApp />} />
        <Route path="/admin" element={<Admin/>} />
        <Route path="/agent" element={<Agent/>} />
        <Route path="/doctor" element={<Doctor/>} />
         <Route path="/senior-marketing-executive" element={<SeniorMarketingExecutive/>} />
         <Route path="/hospital" element={<Hospital/>} />
          <Route path="/diagnostic-center" element={<DiagnosticCenter/>} />
        <Route path="/user" element={<User/>} />
        <Route path="/user-add" element={<UserAdd/>} />
        <Route path="/chamber-add" element={<ChamberAdd/>} />
        <Route path="/user-allocation" element={<UserAllocation/>} />
        <Route path="/category" element={<Category/>} />
        <Route path="/sub-category" element={<SubCategory/>} />
        <Route path="/product" element={<Product/>} />
        <Route path="/audiometer" element={<Audiometer/>} />
          <Route path="/testbooking" element={<Testbooking/>} />
          <Route path="/reffer-patient" element={<RefferProduct/>} />
        <Route path="/service" element={<Service/>} />
        <Route path="/employee" element={<Employee/>} />
        <Route path="/patient" element={<Patient/>} />
        <Route path="/shop-owner" element={<ShopOwner/>} />
        <Route path="/vendor" element={<Vendor/>} />
        <Route path="/holiday" element={<Holiday/>} />
        <Route path="/settings" element={<Settings/>} />
        <Route path="/login" element={<Login/>} />
        <Route path="/signup" element={<SignUp/>} />
        <Route path="/gst-add" element={<GstAdd/>} />
        <Route path="/gst-list" element={<GstList/>} />
        <Route path="/employee-role" element={<EmployeeRole/>} />
        <Route path="/employee-tracking" element={<EmployeeTracking/>} />
        <Route path="/employee-allocation" element={<EmployeeAssign/>} />
        <Route path="/Purchase-bill" element={<PurchaseBillAdd/>} />
        <Route path="/Purchase-bill-list" element={<PurchaseBillList/>} />
        <Route path="/Sell-bill" element={<Pos/>} />
        <Route path="/doctor-payment" element={<DoctorPaymentList/>} />
        <Route path="/add-service" element={<AddService/>} />
        <Route path="/Complete-service" element={<CompleteService/>} />
        <Route path="/Pending-service" element={<PendingService/>} />
        <Route path="/purchase-report" element={<PurchaseReport/>} />
        <Route path="/Sell-bill-list" element={<SellReport/>} />
         <Route path="/sell-report" element={<SellReport/>} />
         <Route path="/income-report" element={<IncomeReport/>}/>
         <Route path="/stock-report" element={<StockReport/>}/>
         <Route path="/gst-purchase-report" element={<GSTPurchaseReport/>}/>
         <Route path="/gst-sell-report" element={<GSTSellReport/>}/>
         <Route path="/expenditure-report" element={<ExpenditureReport/>}/>
         <Route path="/profit-loss-report" element={<ProfitLossReport/>}/>
          <Route path="/salary-report" element={<SalaryReport/>}/>
        <Route path="/profile" element={<Profile/>} />
        <Route path="/work-assign" element={<WorkAssign/>} />
         <Route path="/work-assign-employee" element={<WorkAssignEmployee/>} />
        <Route path="/da-list" element={<DAList/>} />
        <Route path="/create-team" element={<TeamCreate/>} />
        <Route path="/employee-payroll" element={<EmployeePayroll/>} />
        <Route path="/employee-da" element={<DaEmployee/>} />
        <Route path="/review-question" element={<ReviewQuestion/>} />
        <Route path="/order" element={<Order/>} />
        <Route path="/doctor-commesion" element={<DoctorPayRoll/>} />
        <Route path="/doctor-payment" element={<DoctorPaymentList/>} />
        <Route path="/confirm-checkout" element={<ConfirmCheckout/>} />
         <Route path="/confirm-store-checkout" element={<StoreConfirmCheckout/>} />
        <Route path="/order-add-serial-number" element={<OrderAddSerialNumber/>} />
        <Route path="/assign-service-person" element={<AssignServicePerson/>}/>
        <Route path="/service-request-notification-list" element={<ServiceRequentNotification/>}/>
        <Route path="/store-owner" element={<StoreOwner/>} />
          <Route path="/courier-add" element={<CourierAdd/>} />
        <Route path="/courier-list" element={<CourierList/>} />
         <Route path="/customized-booking-create" element={<CustomizedRequest/>} />
         <Route path="/customized-booking-test-data/:id" element={<CustomizeTestData/>} />
         <Route path="/store-wallet-balance" element={<Storewalletbalance/>} />
      </Routes>
    </Router>
  );
}

export default App;